export default __webpack_public_path__ + "static/media/recordme.eb27d7dd.svg";